/**
 * Admin Configuration
 * Defines admin users who have full access to all features
 */

// The ONLY admin email with permanent full access to all features
// Admin users bypass trial periods and subscription requirements
export const ADMIN_EMAILS = [
  'appifiyer@gmail.com'
];

/**
 * Check if an email is an admin email
 * @param {string} email - Email to check
 * @returns {boolean} - True if email is an admin
 */
export function isAdminEmail(email) {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.toLowerCase());
}
